import styled, { css } from "styled-components";

import { IThemeProps } from "@/styles";
import { Animations, fadeIn, moveUpAndFadeIn } from "@/styles/Mixins";

type BackgroundProps = IThemeProps<{
  hasScrollbar: boolean;
}>;
export const Background = styled.div<BackgroundProps>`
  ${(props: BackgroundProps) => props.hasScrollbar && Scroll};
  ${(props: BackgroundProps) => !props.hasScrollbar && Stretch};
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props: BackgroundProps) => props.theme.colors.overlay};
  /* z-index because of "Vielen Dank für Ihre Teilnahme!" overlay */
  z-index: ${(props: IThemeProps) => props.theme.zIndex.h300};
  opacity: 0;
  animation: ${fadeIn} 0.2s ease-in;
  animation-fill-mode: forwards;
`;

const Stretch = css`
  position: absolute;
`;

const Scroll = css`
  position: fixed;
  overflow: hidden auto;
`;

type OverlayWrapperProps = IThemeProps<{
  animation: Animations.FADE_IN | Animations.MOVE_UP_AND_FADE_IN;
}>;
export const OverlayWrapper = styled.div<OverlayWrapperProps>`
  min-width: 306px; /* iPhone SE 1st gen - 320px minus padding */
  padding: 3px 7px;
  margin: auto;
  opacity: 0;
  ${(props: OverlayWrapperProps) =>
    props.animation === Animations.FADE_IN && FadeInAnimation};
  ${(props: OverlayWrapperProps) =>
    props.animation === Animations.MOVE_UP_AND_FADE_IN &&
    MoveUpAndFadeInAnimation};
`;

const FadeInAnimation = css`
  animation-name: ${fadeIn};
  animation-duration: 100ms;
  animation-timing-function: ease-in;
  animation-delay: 200ms;
  animation-fill-mode: forwards;
`;

const MoveUpAndFadeInAnimation = css`
  animation-name: ${moveUpAndFadeIn({ size: "50px" })};
  animation-duration: 250ms;
  animation-timing-function: linear;
  animation-delay: 500ms;
  animation-fill-mode: forwards;
`;
